import { WorkspacesPage } from '@carboncopyco/components';
import { useParams } from 'react-router-dom';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';

export const WorkspacesRoute = () => {
  const { organizationId } = useParams();
  const { navigateToWorkspace, links } = useCustomNavigate();

  return (
    <div className="flex grow shrink justify-center bg-ds-accent3-100 overflow-hidden">
      <div className="flex justify-center bg-ds-accent3-100 w-[1185px]">
        {organizationId && (
          <WorkspacesPage
            organizationId={organizationId}
            navigateToWorkspace={navigateToWorkspace}
            getWorkspaceLink={links.getWorkspaceLink}
          />
        )}
      </div>
    </div>
  );
};
